<template>
    <nav class="flex px-2 py-6 sm:px-6 lg:px-8" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
            <li>
                <div>
                    <Link :href="route('frontend.fixture.index')" class="text-gray-400 hover:text-gray-500">
                        <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
                        <span class="sr-only">Home</span>
                    </Link>
                </div>
            </li>
            <li v-if="$page.props.breadcrumbs" v-for="page in $page.props.breadcrumbs" :key="page.name">
                <div class="flex items-center">
                    <ChevronRightIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                    <Link :href="page.url" class="ml-4 text-sm text-gray-500 hover:text-gray-700" :class="{'font-medium':page.is_current_page}" :aria-current="page.is_current_page ? 'page' : undefined">{{ page.title }}</Link>
                </div>
            </li>
        </ol>
    </nav>
</template>

<script>
import { ChevronRightIcon, HomeIcon } from '@heroicons/vue/solid'
import { Link } from "@inertiajs/vue3";

export default {
    components: {
        ChevronRightIcon,
        HomeIcon,
        Link
    }
}
</script>
